import * as Yup from 'yup';

export const cityValidation = Yup.string()
  .matches(
    /^[a-zA-Z'. -]*$/,
    "City can only contain letters, spaces, and the characters (.-')"
  )
  .max(30, 'City can not be longer than 30 letters');
